import { useNavigate } from 'react-router-dom';
import { Button, Text } from '@cabonline/ui-web';
import { colors } from '@cabonline/ui-shared';
import { WarningAmberOutlined } from '@mui/icons-material';
import { useCallback } from 'react';
import { useAuth, useLocale } from '@multiplatform-apps/service-trips';
import {
  StyledErrorContainer,
  StyledErrorWrapper,
} from '../../components/error-view';
import { useDeviceType, usePermissions } from '../../hooks';
import { paths } from '../../constants';

export const ForbiddenBody = () => {
  const navigate = useNavigate();
  const { t } = useLocale();
  const { hasRootRoutePermission: hasPermission } = usePermissions();
  const { logout } = useAuth();

  const onReturnToStartPagePress = useCallback(() => {
    if (hasPermission('tripsPage')) {
      navigate('/');
    } else {
      logout();
      navigate(paths.landingPage);
    }
  }, [hasPermission, logout, navigate]);

  return (
    <>
      <WarningAmberOutlined fontSize="large" />
      <Text weight="extraBold" size="xl">
        {t('forbidden.title')}
      </Text>
      <Text weight="semi" size="l" color={colors.gray2} marginBottom="m">
        {t('forbidden.description')}
      </Text>
      <Button
        label={t('error.generic.returnButton')}
        onClick={onReturnToStartPagePress}

      />
    </>
  );
};

export const Forbidden = () => {
  const deviceType = useDeviceType();
  return (
    <StyledErrorWrapper isMobile={deviceType === 'mobile'}>
      <StyledErrorContainer>
        <ForbiddenBody />
      </StyledErrorContainer>
    </StyledErrorWrapper>
  );
};
